import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Navbar from './components/Navbar';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import EventForm from './pages/EventForm';
import EventDetails from './pages/EventDetails';
import PublicRegistration from './pages/PublicRegistration';
import WhatsAppConfig from './pages/WhatsAppConfig';
import ReminderForm from './pages/ReminderForm';
import ChangePasswordModal from './pages/ChangePasswordModal';

function App() {
  const { isAuthenticated, user, updateUser } = useAuth();
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  useEffect(() => {
    if (user?.isCollaborator && user?.mustChangePassword) {
      setShowPasswordModal(true);
    }
  }, [user]);

  const handlePasswordChangeSuccess = () => {
    setShowPasswordModal(false);
    console.log('Password changed successfully, updating user state...');
    updateUser({ ...user, mustChangePassword: false });
  };

  return (
    <>
      {isAuthenticated && <Navbar />}
      {showPasswordModal && (
        <ChangePasswordModal onSuccess={handlePasswordChangeSuccess} />
      )}
      <Routes>
        <Route path="/" element={!isAuthenticated ? <LandingPage /> : <Navigate to="/dashboard" />} />
        <Route path="/login" element={!isAuthenticated ? <Login /> : <Navigate to="/dashboard" />} />
        <Route path="/register" element={!isAuthenticated ? <Register /> : <Navigate to="/dashboard" />} />
        
        <Route path="/evento/:token" element={<PublicRegistration />} />
        
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/events/new" element={<PrivateRoute><EventForm /></PrivateRoute>} />
        <Route path="/events/:id/edit" element={<PrivateRoute><EventForm /></PrivateRoute>} />
        <Route path="/events/:id/reminders/:reminderId/edit" element={<PrivateRoute><ReminderForm /></PrivateRoute>} />
        <Route path="/events/:id/reminders/new" element={<PrivateRoute><ReminderForm /></PrivateRoute>} />
        <Route path="/events/:id" element={<PrivateRoute><EventDetails /></PrivateRoute>} />
        <Route path="/whatsapp" element={<PrivateRoute><WhatsAppConfig /></PrivateRoute>} />
        
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
}

export default App;
